/**
 * Copyright © 2026 Adnuntius AS.
 */
import {AdnListHelperService} from '../../common/controller/list-helper.service';
import {Component, Inject, OnInit} from '@angular/core';
import {MarketplaceProductResource} from '../../../components/api/resources/resource/marketplace-product.resource';
import {LocalUserPermissions} from '../../../components/session/local-user-permissions';

@Component({
  standalone: false,
  selector: 'adn-marketplace-product-route-page',
  template: `
    <adn-marketplace-product-list-page
      *ngIf="list"
      [list]="list">
    </adn-marketplace-product-list-page>
  `
})
export class MarketplaceProductRoutePageComponent implements OnInit {
  list: any = {};

  constructor(
    private adnListHelper: AdnListHelperService,
    @Inject(MarketplaceProductResource) private MarketplaceProduct: any,
    @Inject(LocalUserPermissions) private LocalUserPermissions: any
  ) {}

  ngOnInit(): void {
    const perms = this.LocalUserPermissions.getAllNetworkPermissions();
    const readOnly = !perms.AX_PUBLISHER_ADMIN && !perms.MANAGE_SYSTEM;

    this.adnListHelper.setUpList(this.list, this.MarketplaceProduct, readOnly, 'fullMarketplaceProductList', {
      baseTable: 'axProduct',
      getDefaultOrderByParam: function() {
        return 'name';
      }
    });
  }
}
